import api from './index'
import request from '@/utils/request'

export function getVisitProvinceStatist(data) {
  return request({
    url: api.visitPStatist,
    method: 'post',
    data
  })
}
export function getWorkProvinceStatist(data) {
  return request({
    url: api.workPStatist,
    method: 'post',
    data
  })
}

export function getVisitDateStatist(data) {
  return request({
    url: api.vistByDate,
    method: 'post',
    data
  })
}
export function getLoginRecordDateStatist(data) {
  return request({
    url: api.loginRecordByDate,
    method: 'post',
    data
  })
}
export function getWorkDateStatist(data) {
  return request({
    url: api.workStatistByDate,
    method: 'post',
    data
  })
}
export function getUserAddStatist(data) {
  return request({
    url: api.userAddCount,
    method: 'post',
    data
  })
}


